module.exports = __webpack_public_path__ + "img/open_door.39f1ab82.png";